export default "__VITE_ASSET__4523eb21__"